package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.FormatItalicW500Rounded: ImageVector
    get() {
        if (_formatItalicW500Rounded != null) {
            return _formatItalicW500Rounded!!
        }
        _formatItalicW500Rounded = Builder(name = "FormatItalicW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(249.52f, 767.89f)
                quadToRelative(-23.15f, 0.0f, -39.32f, -16.17f)
                quadToRelative(-16.18f, -16.18f, -16.18f, -39.33f)
                reflectiveQuadToRelative(16.18f, -39.32f)
                quadToRelative(16.17f, -16.18f, 39.32f, -16.18f)
                horizontalLineToRelative(105.94f)
                lineToRelative(117.84f, -353.3f)
                lineTo(370.96f, 303.59f)
                quadToRelative(-23.16f, 0.0f, -39.33f, -16.18f)
                quadToRelative(-16.17f, -16.17f, -16.17f, -39.32f)
                quadToRelative(0.0f, -23.16f, 16.17f, -39.33f)
                quadToRelative(16.17f, -16.17f, 39.33f, -16.17f)
                horizontalLineToRelative(300.0f)
                quadToRelative(23.15f, 0.0f, 39.32f, 16.17f)
                quadToRelative(16.18f, 16.17f, 16.18f, 39.33f)
                quadToRelative(0.0f, 23.15f, -16.18f, 39.32f)
                quadToRelative(-16.17f, 16.18f, -39.32f, 16.18f)
                horizontalLineToRelative(-85.94f)
                lineToRelative(-117.85f, 353.3f)
                horizontalLineToRelative(82.35f)
                quadToRelative(23.15f, 0.0f, 39.33f, 16.18f)
                quadToRelative(16.17f, 16.17f, 16.17f, 39.32f)
                reflectiveQuadToRelative(-16.17f, 39.33f)
                quadToRelative(-16.18f, 16.17f, -39.33f, 16.17f)
                horizontalLineToRelative(-300.0f)
                close()
            }
        }
        .build()
        return _formatItalicW500Rounded!!
    }

private var _formatItalicW500Rounded: ImageVector? = null
